import React, { useEffect, useState } from 'react'
import './ErrorPage.scss'
import CircularProgressWithLabel from './componets/CircularProgressWithLabel';
import { useNavigate } from 'react-router-dom';

export default function Forbidden() {

    const [progress, setProgress] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prev) => {
                const next = prev + 5;
                if (next >= 100) {
                    clearInterval(timer);
                    // Redirect after short delay if needed
                    setTimeout(() => navigate('/dashboard'), 500); // Optional delay
                }
                return next;
            });
        }, 800);

        return () => clearInterval(timer);
    }, [navigate]);
    return (
        <div className='errorpage'>
            <div className='wraper'>
                <div className="code_404">
                    403
                </div>
                <div className="notfound">
                    Oops! You don't have permission to access this page....
                </div>
                <p>
                    You do not have the necessary permissions to access this page. If you believe this is a mistake or you require access to this resource, please contact your administrator or manager for assistance.
                </p>

                <div className="components">
                    <button className='btn_gohaome' onClick={() => window.location.href = '/dashboard'}>
                        Go to Home
                    </button>
                    <div className="loader">
                        <CircularProgressWithLabel value={progress} size={35} thickness={5} color="primary" />
                    </div>
                </div>


            </div>
        </div>

    )
}
